
import { environment } from "../../../../Environments/environment";
import { PostAsyncHelper } from "../../../../redux/interfaces/types";


export const GetMuvBookings = async (uuid) => {


    let api_url = `${environment.apiUrl}muv-meta-engine/expedia/getAllMemberBookings?uuid=${uuid}`;
    // let api_url = `${environment.apiUrl}muv-meta-engine/expedia/getAllMemberBookings?uuid=${'625853a8-95b2-11ed-b44f-42010a8e0003'}`;
    const response = await PostAsyncHelper(api_url, {});
    const results = response?.data?.result;
    return results || null;
};
